import { createContext, useState, useContext } from 'react';

const PositionAtividadeContext = createContext();

export function PositionProvider({ children }) {
    const [positionCurrent, setpositionCurrent] = useState(0); // Valor inicial

    return (
        <PositionAtividadeContext.Provider value={{ positionCurrent, setpositionCurrent }}>
            {children}
        </PositionAtividadeContext.Provider>
    );
}

export function usePosition() {
    return useContext(PositionAtividadeContext);
}
